// extracted by mini-css-extract-plugin
export default {"expiryAlert":"ResumeApplication_expiryAlert__6fs-Z"};